import { Map } from "ol";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";
import { LuodeDto } from "~/api/GeneratedApi";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { luodeToMapItem } from "./dataConverters";
import { findSourceByTitle } from "./findSourceByTitle";

export function addLuodeToMap(map: Map, data: LuodeDto[]): void {
  // Find the layer and add the features
  const source = findSourceByTitle(map, LayerTitle.Conditions);
  // Clear the source before adding
  source.clear();
  const features: Feature<Geometry>[] = [];
  data.forEach((d) => {
    if (!d.x || !d.y) return;
    // Convert to internal type
    const convertedData = luodeToMapItem(d);
    const point = new Point([convertedData.x, convertedData.y]);
    const feat = new Feature({
      geometry: point,
    });
    feat.setProperties({ ...convertedData });
    feat.set("overlayOffsetY", -24);
    feat.setId(convertedData.mapId);
    features.push(feat);
  });
  source.addFeatures(features);
  source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
}
